
import { Component, Vue } from 'vue-property-decorator';
import SAccNavigation from "@/components/SAccNavigation.vue";
import { AccountDocument } from "@/interfaces/account.interfaces";

@Component({
  components: {SAccNavigation}
})
export default class SAccTopLayout extends Vue {
  // Les props
  // Les propriétés
  private isdraw: boolean = true;

  // Les propriétés calculées
  private get theme() {
    return this.$store.state.theme
  }

  private get fullname(): string | null {
    const user = this.$store.state.user;
    return user ? `${user.firstname} ${user.lastname}` : null;
  }

  private get workspace() {
    return `${this.accountLabel} ${this.$store.getters['workspace']}`
  }

  private get accountLabel() {
    const acc: AccountDocument | null = this.$store.state.accountData
    return acc ? acc.label : ''
  }

  // Les hooks
  public async mounted() {
    await this.$store.dispatch('getAccountData')
  }

  // Les méthodes surveillées
  // Les méthodes d'instance
  // Les méthodes statiques
}
